import {
    EBookRecommendationDataDto,
    RecommendationDto
} from '../apis/nhe-remediation-service/nhe-remediation-service.dtos';

export const getEbookRecommendationData = (recommendation: RecommendationDto): EBookRecommendationDataDto => {
    if (!recommendation || !recommendation.recommendationData) {
        return null;
    }
    return recommendation.recommendationData as EBookRecommendationDataDto;
};
export const getEbookRecommendationSubsection = (recommendation: RecommendationDto): EBookRecommendationDataDto['breadCrumbs'][0] => {
    const recommendationData = getEbookRecommendationData(recommendation);
    if (!recommendationData || !recommendationData.breadCrumbs) {
        return null;
    }
    return recommendationData.breadCrumbs[recommendationData.breadCrumbs.length - 1];
};

export const isRangeSamePage = (firstPage: number, lastPage: number): boolean => {
    if (!firstPage && !lastPage) {
        return false;
    }

    return firstPage == lastPage;
};

export const getEbookTitleWithPagesDisplay = (recommendation: RecommendationDto): string => {
    const ebookData = getEbookRecommendationData(recommendation);
    const subSection = getEbookRecommendationSubsection(recommendation);
    const pageRangeText = isRangeSamePage(subSection?.page_range?.[0], subSection?.page_range?.[1])
        ? `pg. ${subSection.page_range[0]}`
        : `pgs. ${subSection.page_range[0]} - ${subSection.page_range[1]}`;

    const titleParts = [];
    ebookData?.title && titleParts.push(ebookData.title);
    subSection?.page_range && titleParts.push(pageRangeText);
    return titleParts.length > 0 ? titleParts.join(', ') : null;
};
